export default __webpack_public_path__ + "static/media/user_guide4.dcf446d9.png";